export const PAYMENT = Object.freeze({
    ACH: 'ACH',
    WIRE: 'Wire',
    CHECK: 'Check',
    FIAT: 'USD',
    FIAT_DEPRECATED: 'Paper',
});